var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusCircleDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(-50 -28)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M64.844 28C56.657 28 50 34.657 50 42.844s6.657 14.843 14.844 14.843 14.844-6.656 14.844-14.843C79.688 34.657 73.03 28 64.844 28zm6.125 16.468h-4.5v4.47c0 .905-.72 1.624-1.625 1.624-.906 0-1.625-.719-1.625-1.624v-4.47h-4.5c-.906 0-1.625-.719-1.625-1.624 0-.906.719-1.625 1.625-1.625h4.469v-4.5c0-.906.719-1.625 1.624-1.625.906 0 1.625.719 1.625 1.624v4.47h4.47c.905 0 1.624.718 1.624 1.624.001.907-.656 1.657-1.561 1.657z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircleDark);
export default __webpack_public_path__ + "static/media/plus-circle-dark.54331c68.svg";
export { ForwardRef as ReactComponent };